<template>
  <p>
    Para visualizar o boleto desta parcela acesse o
    <a href="https://renegociacao.itau.com.br/" target="_blank" rel="noopener">portal de renegociação do Itaú</a>.
  </p>
</template>
